// extracted by mini-css-extract-plugin
export var active = "_96-1";
export var activeSubdued = "_96-2";
export var compact = "_96-3";
export var fill = "_96-6";
export var pulse = "_96-4";
export var settingHighlightPulse = "_96-5";
export var wrapper = "_96-0";